<template>
  <v-dialog :value="showModal" persistent width="500">
    <v-card class="pa-5 ">
      <div class="text-center">
        <h3>{{ $t("exchange.ocoOrderInfoModal.title") }}</h3>
      </div>
      <div class="font-Regular-14 terms-modal-body text-justify">
        <v-radio-group v-model="ocoOrderType" row class="oco-info-modal">
          <v-radio
            :label="$t('exchange.ocoOrderInfoModal.buyOrder')"
            class="ms-3"
            value="buy"
          >
          </v-radio>
          <v-radio
            value="sell"
            :label="$t('exchange.ocoOrderInfoModal.sellOrder')"
            class="ms-3"
          >
          </v-radio>
        </v-radio-group>
        <v-row class="mx-3" v-if="ocoOrderType === 'buy'">
          <img alt="" src="@/assets/image/ocoInfoBuy.svg" />
          <p class="mb-4 modal-text modal-text-decoration">
            {{ $t("exchange.ocoOrderInfoModal.ocoTrades") }}
          </p>

          <p class="mb-1 modal-text modal-text-decoration">
            {{ $t("exchange.ocoOrderInfoModal.buyTrades") }}
          </p>

          <ul class="modal-text mb-4 ms-4">
            <li>
              {{ $t("exchange.ocoOrderInfoModal.buyStop") }}
            </li>

            <li>
              {{ $t("exchange.ocoOrderInfoModal.buyLimit") }}
            </li>
          </ul>

          <p class="mb-4 modal-text modal-text-decoration">
            {{ $t("exchange.ocoOrderInfoModal.desc1") }}
          </p>

          <p class="mb-1 modal-text warning-text">
            {{ $t("exchange.ocoOrderInfoModal.notice") }}
          </p>

          <ul class="modal-text mb-4 ms-4">
            <li>
              {{ $t("exchange.ocoOrderInfoModal.desc2") }}
            </li>
          </ul>
        </v-row>
        <v-row type="flex" class="mx-3" v-if="ocoOrderType === 'sell'">
          <img alt="" src="@/assets/image/ocoInfoSell.svg" />
          <p class="mb-4 modal-text modal-text-decoration">
            {{ $t("exchange.ocoOrderInfoModal.desc3") }}
          </p>

          <p class="mb-1 modal-text modal-text-decoration">
            {{ $t("exchange.ocoOrderInfoModal.sellTrades") }}
          </p>

          <ul class="modal-text mb-4 ms-4">
            <li>
              {{ $t("exchange.ocoOrderInfoModal.sellStop") }}
            </li>

            <li>
              {{ $t("exchange.ocoOrderInfoModal.sellLimit") }}
            </li>
          </ul>

          <p class="mb-4 modal-text modal-text-decoration">
            {{ $t("exchange.ocoOrderInfoModal.desc4") }}
          </p>

          <p class="mb-1 modal-text warning-text">
            {{ $t("exchange.ocoOrderInfoModal.notice") }}
          </p>

          <ul class="modal-text mb-4 ms-4">
            <li>
              {{ $t("exchange.ocoOrderInfoModal.desc5") }}
            </li>
          </ul>
        </v-row>
      </div>
      <div>
        <v-btn
          class="font-Medium-14 d-block"
          block
          color="primary"
          @click="$emit('onConfirm')"
        >
          {{ $t("exchange.ocoOrderInfoModal.understood") }}
        </v-btn>
        <!--        <Button class="font-Medium-14 ms-2" @click="$emit('onCancel')">{{$t('uc.denyTermsOfUse')}}</Button>-->
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "ocoOrderInfoModal",
  props: {
    showModal: {
      type: Boolean
    }
  },
  data() {
    return {
      ocoOrderType: "buy"
    };
  }
};
</script>
<style scoped lang="scss"></style>
